import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { GuestEntity } from '@seaters/constants';

export interface GuestItem {
  specialGuestId?: string;
  tickets: number;
  guest: GuestEntity;
  isToAllocated?: boolean;
  order?: number;
  // Host motivation captured when the guest was added; submitted as the
  // invitation's reason so the organiser sees it (prototype).
  motivation?: string;
}

type State = {
  guests: {
    [guestId: string]: GuestItem;
  };
  totalTickets: number;
};

type Actions = {
  add: (
    guest: GuestEntity,
    tickets: number,
    isToAllocated?: boolean,
    motivation?: string
  ) => void;
  addAll: (guests: { [guestId: string]: GuestItem }) => void;
  setTickets: (guestId: string, tickets: number) => void;
  remove: (guestId: string) => void;
  setTotalTickets: (tickets: number) => void;
  reset: () => void;
};

const initialState: State = {
  guests: {},
  totalTickets: 0,
};

export const useGuestListStore = create<State & Actions>()(
  devtools((set) => ({
    ...initialState,
    setTotalTickets: (tickets) =>
      set(() => ({
        totalTickets: tickets,
      })),
    addAll: (guests) =>
      set(() => ({
        guests,
      })),
    add: (guest, tickets, isToAllocated, motivation) =>
      set((state) => ({
        guests: {
          ...state.guests,
          [guest.guestId]: { tickets, guest, isToAllocated, motivation },
        },
      })),
    setTickets: (guestId, tickets) =>
      set((state) => ({
        guests: {
          ...state.guests,
          [guestId]: { ...state.guests[guestId], tickets },
        },
      })),
    // addList: (guests) => set(() => ({ guestList: guests })),
    remove: (guestId) =>
      set((state) => {
        const guestsCopy = { ...state.guests };
        delete guestsCopy[guestId];

        return {
          guests: guestsCopy,
        };
      }),

    reset: () => {
      set(initialState);
    },
  }))
);
